/*
semsomi AB
Copyright (c) 2016-2017
All rights reserved
*/

import * as types from '../actions/actionTypes';
const config = require('../../settings/config.json');

const initialState = {selectedView: window.selectedView ? window.selectedView: (window.feeds && window.feeds[0] ? window.feeds[0].id : 'en')}

if(window.search){
	initialState.selectedView = "search"// window.feeds.length + config.tabs.findIndex(f=>f.type==="search")
}

const view = function(state = initialState, action) {
  switch(action.type) {
  	case types.GOTO_VIEW:
  		return {selectedView: action.feedIndex}
  	// TODO: this should not be used
  	// case types.GOTO_RIGHT_VIEW:
  	// 	return 4
  	// case types.GOTO_LEFT_VIEW:
  	// console.log("reducer")
  		
  	// 	const selectedView = state.selectedView>0 ? state.selectedView-1 : 0
  		
  	// 	return {...state,
  	// 		selectedView:selectedView
  	// 	}

  }

  return state;

}

export default view;


